import { h } from 'preact';
import { Modal } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import style from './style.css';
import { AppConstant } from '../../constant/AppConstant';
import Configuration from '../../constant/configuration';
import { withQrLaunchParam } from '../../utils/chromeIosRelayout';
import QrCode from '../qr-code';
import { DESKTOP_SUPPORT, allowsDesktopSetup } from '../../utils/addDeviceRouting';

// Which sentence the demoted desktop card shows. Keyed by DESKTOP_SUPPORT so a
// new engine verdict is one map entry, not a new branch.
const DESKTOP_TEXT_KEY = {
  [DESKTOP_SUPPORT.SUPPORTED]: AppConstant.ADD_DEVICE_DESKTOP_BODY,
  [DESKTOP_SUPPORT.UNKNOWN]: AppConstant.ADD_DEVICE_DESKTOP_UNKNOWN,
  [DESKTOP_SUPPORT.BLOCKED_PNA]: AppConstant.ADD_DEVICE_DESKTOP_UNSUPPORTED,
  [DESKTOP_SUPPORT.BLOCKED_WEBKIT]: AppConstant.ADD_DEVICE_DESKTOP_UNSUPPORTED,
};

/**
 * Desktop-only pre-flight shown before Add Device leaves for dash.kegtron.com.
 *
 * Every state leads with the phone: the native app owns Wi-Fi provisioning and
 * is the only route that works in all browsers. Desktop sits underneath as the
 * demoted option, and on an engine that provably cannot finish (Chromium's PNA
 * block, Safari's HTTPS upgrade) it becomes an instruction rather than a button.
 *
 * @param {object}   props
 * @param {boolean}  props.open      - whether the dialog is visible
 * @param {string}   props.support   - a DESKTOP_SUPPORT value
 * @param {Function} props.onClose   - dismiss handler
 * @param {Function} props.onContinue - commit to the desktop flow (builds the
 *                     token URL at that moment; see addDeviceRouting)
 */
function AddDeviceModal({ open, support, onClose, onContinue, t }) {
  const canContinue = allowsDesktopSetup(support);
  const desktopTextKey =
    DESKTOP_TEXT_KEY[support] || AppConstant.ADD_DEVICE_DESKTOP_UNKNOWN;

  return (
    <Modal show={open} onHide={onClose} aria-labelledby="add-device-modal-title">
      {/* No closeButton: the footer's Close is the single dismiss control, and
          a second "x" in the header only duplicates it. */}
      <Modal.Header>
        <h5 class="modal-title" id="add-device-modal-title">
          {t(AppConstant.ADD_DEVICE_TITLE)}
        </h5>
      </Modal.Header>

      <Modal.Body>
        <div class={style.body}>
          <div class={`${style.route} ${style.routeLead}`}>
            <div class={style.qr}>
              <QrCode
                value={withQrLaunchParam(Configuration.dashboardUrl)}
                title={t(AppConstant.ADD_DEVICE_QR_ALT)}
              />
            </div>
            <div class={style.routeBody}>
              <h6 class={style.routeTitle}>
                {t(AppConstant.ADD_DEVICE_PHONE_TITLE)}
                <span class={style.pill}>{t(AppConstant.ADD_DEVICE_RECOMMENDED)}</span>
              </h6>
              <p class={style.routeText}>{t(AppConstant.ADD_DEVICE_PHONE_BODY)}</p>
            </div>
          </div>

          <div class={`${style.route} ${style.routeAlt}`}>
            <div class={style.routeBody}>
              {canContinue && (
                <h6 class={style.routeTitle}>
                  {t(AppConstant.ADD_DEVICE_DESKTOP_TITLE)}
                </h6>
              )}
              <p class={style.routeText}>{t(desktopTextKey)}</p>
              {canContinue && (
                <button
                  type="button"
                  class={`btn btn-outline-secondary ${style.continueButton}`}
                  onClick={onContinue}
                >
                  {t(AppConstant.ADD_DEVICE_DESKTOP_CONTINUE)}
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" class="btn btn-link text-muted" onClick={onClose}>
          {t(AppConstant.ADD_DEVICE_CLOSE)}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export { AddDeviceModal }; // unwrapped for unit tests
export default withTranslation()(AddDeviceModal);
